export default __webpack_public_path__ + "static/media/fake_photo.a8759827.png";